export default __webpack_public_path__ + "static/media/insta.7b6059e5.svg";